import {useState, Children} from 'react'
import {useHistory} from 'react-router-dom';
import './Appbar.css';

export const Appbar = (props) => (
  <div className="Appbar">{props.children}</div>
);

export default Appbar;
